import { Config } from '../../src/types';

export default {
  store: {
    state: {
      constants: {
        PAY_FREQUENCIES: [{
          value: 52,
          text: 'Weekly',
          single: 'weekly',
        }, {
          value: 26,
          text: 'Fortnightly',
          single: 'fortnightly',
        }, {
          value: 12,
          text: 'Monthly',
          single: 'monthly',
        }, {
          value: 1,
          text: 'Annually',
          single: 'annual',
        }],
      },
      ui: {
        precision: {
          percent: 1,
        },
      },
      features: {
        employerMatch: false,
      },
      copy: {
        name: 'Vaillant',
        outputs: {
          employer: '',
        },
        legend: {
          employer: '',
        },
        tooltips: {
          salaryInput: '',
          annualMonthly: '',
        },
      },
      assumptions: {
        contributionRates: [0.03, 0.04, 0.065],
        employerMatch: {
          101: {
            employee: [0.03, 0.04, 0.065],
            employer: [0, 0, 0],
          },
        },
      },
    },
  },

  hooks: {
    // beforeInitialise(vm, store) {},
    // afterInitialise(vm, store) {},
  },
} as Config;
